<template>
<div id="index">
  <div class="desktop">
    <div class="backMusic">
      <audio controls ref="backgroundMusic" loop hidden>
        <source :src="musicBack">
      </audio>
      <button @click="backMusicPause('backgroundMusic')">♬</button>
      <br/>
      <button class="langs" @click="handleChangeLang('tw')">繁體中文</button>
      <button class="langs" @click="handleChangeLang('cn')">简体中文</button>
      <button class="langs" @click="handleChangeLang('bo')"> བོད་ཡིག </button>
    </div>

    <div class="openBook">
      <div class="container" @click="openThisBook()">
        <div class="intro">
          <div class="contentwrap">
            <div class="back">
              <div class="links">
                <router-link to="/avatamsaka">
                  <img src="static/image/indexCover02.png" alt="image" width="100%">
                </router-link>
              </div>
              <div class="imgScript">
                {{$t('avatamsaka.index.slider01')}}<br/>
                {{$t('avatamsaka.index.slider02')}}
              </div>
            </div>
            <div class="content">
              <br/>
              {{$t('avatamsaka.history.area01content')}}
            </div>
            <div class="links">
              <router-link to="/avatamsaka">
                ↳ {{$t('avatamsaka.menu.webContra')}}
              </router-link>
            </div>
          </div>
        </div>
        <div :class="['cover', {openIt: isOpen}]">
          <div class="front">
            <div class="titleFrame">
              <div class="insideFrame">
                <div class="titleC">
                  {{$t('homepage.index.avatamsaka')}}
                </div>
                <div class="title">
                  ཕལ་ཆེན།
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile">
    <div class="links">
      <router-link to="/avatamsaka">
        {{$t('avatamsaka.menu.webContra')}}
      </router-link>
    </div>

    <div class="changLang">
      <b-button class="langs" @click="handleChangeAndInto('tw')">繁體中文</b-button>
      <b-button class="langs" @click="handleChangeAndInto('cn')">简体中文</b-button>
      <b-button class="langs" @click="handleChangeAndInto('bo')"> བོད་ཡིག </b-button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    musicBack() {
      return '/static/mp3/香水蓮花PIC02.mp3';
    },
    musicArea01() {
      const url = this.musicFile('01');
      return url;
    },
    musicArea02() {
      const url = this.musicFile('02');
      return url;
    },
  },
  methods: {
    backMusicPause(now) {
      if (this.$refs[now].paused) {
        this.$refs[now].play();
      } else {
        this.$refs[now].pause();
      }
    },
    openThisBook() {
      this.isOpen = !this.isOpen;
    },
    handleChangeLang(langs) {
      this.$i18n.locale = langs;
    },
    handleChangeAndInto(langs) {
      this.$i18n.locale = langs;
      this.$router.push({
        path: '/avatamsaka',
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#index {
min-height: 100vh;
background: rgb(251, 238, 234);
background-image: url('/static/image/index/background01.png');
background-position: bottom left;
background-repeat: no-repeat;
background-size: 60%;
padding: 0.2em 0px;
button:hover {
  cursor: pointer;
}

.backMusic {
  position: sticky;
  float: right;
  top: 4em;
  height: 0px;
  z-index: 3;
  button {
    margin-top: 2em;
    margin-bottom: 2em;
    padding: 0.3em;
    padding-left: 0.6em;
    background: rgba(2, 39, 10, 0.6);
    border: solid 4px #ffffff9d;
    border-right: none;
    color: #ffffff;
    font-weight: bolder;
    float: right;
    width: 7em;
  }
  .langs {
    width: 7em;
    float: right;
    margin: 0.1em 0px;
    padding: 0.3em;
    padding-left: 0.6em;
    background: rgba(2, 39, 10, 0.6);
    border: solid 4px #ffffff9d;
    border-right: none;
    color: #ffffff;
    font-weight: bolder;
    display: block;
    clear: both;
  }
}

.openBook {
  position: relative;
  padding-left: 15vw;
  .container {
    -webkit-filter: drop-shadow(-12px 12px 7px rgba(0, 0, 0, 0.4));
    filter: drop-shadow(-12px 12px 7px rgba(0, 0, 0, 0.4));
    background: #2d384e;
    width: 36vw;
    height: 50vw;
    max-height: 70vh;
    min-height: 50vw;
    margin: 2em auto;
    transform: translate(0%, 0%);
    perspective: calc(36vw * 6);
    .intro {
      display: flex;
      align-items: center;
      align-content: center;
      background: #f6ebc6;
      overflow: hidden;
      height: 100%;
      position: absolute;
      padding: 2em;
      margin-left: 26px;
      padding-left: 2em;
      .content {
        text-align: left;
        font-size: 0.9em;
        overflow: scroll;
        padding-bottom: 2em;
      }
      .links {
        min-height: 1.5em;
        background: #505444;
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
    }

    .cover {
      width: calc(36vw - 35px);
      height: 100%;
      position: absolute;
      left: 40px;
      background: #f6ebc6;
      transform: rotateY(0deg);
      transform-style: preserve-3d;
      transform-origin: left;
      transition: all .5s ease-in;

      >div {
        margin: 0;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
      }

      .front {
        -webkit-filter: drop-shadow(-4px 0px 27px rgba(0, 0, 0, 0.2));
        filter: drop-shadow(-4px 0px 27px rgba(0, 0, 0, 0.2));
        background: #0b1f4cc2;
        border-left: 2px solid rgba(156, 141, 89, 0.705);
        .titleFrame {
          position: absolute;
          top: 2em;
          left: 2em;
          background: #fcf9f2;
          border: 3px solid rgba(198, 178, 113, 0.705);
          padding: 5px;
          .insideFrame {
            padding: 2em 0.3em;
            border: 2px solid rgba(198, 178, 113, 0.705);
            .titleC {
              text-align: center;
              font-size: 2em;
              padding-right: 0.2em;
              -webkit-writing-mode: vertical-rl;
              writing-mode: vertical-rl;
              background: #fcf9f2;
              padding-bottom: 1em;
              border-bottom: 2px solid rgba(198, 178, 113, 0.705);
            }
            .title {
              font-size: 2em;
              padding-top: 1em;
              -webkit-writing-mode: vertical-rl;
              writing-mode: vertical-rl;
              background: #fcf9f2;
            }
          }
        }
      }
      .back {
        transform: rotateY(180deg);
        padding: 2em;
        display: flex;
        background: #f6ebc6;
        flex-direction: column;
        border-right: 2px solid #d8ceaec7;
        .imgScript {
          flex: 1;
          text-align: center;
          font-size: 0.8em;
          line-height: 1.3em;
          color: #35493f;
          overflow: scroll;
          padding-top: 3px;
        }
        .links {
          flex: initial;
          background: #505444;
          color: #ffffff;
          a {
            color: #ffffff;
          }
          margin-bottom: 0.4em;
        }
      }
    }

    .openIt {
      transform: rotateY(-180deg);
    }
  }
}

@media (max-width: 768px) {
  h2 {
    font-size: 1.3em;
  }
}

@media (max-width: 1380px) {
  padding: 0px;
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
    min-height: 100vh;
    text-align: center;
    flex-direction: column;
    .links {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
    .changLang {
      flex: 1;
    }
  }
}

@media (min-width: 1380px) {
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
}

}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue